import { CostCenter, SimpleDepartmentResponse, UserSimpleResponse } from './core'
import {
  ProcurementPriority,
  ProcurementCreationStatus,
  PurchaseRequestItemType,
  QuoteType,
  ProcurementStatus,
  ProcurementRequestClientStatus,
} from './enums'
import { SimpleInventoryItemResponse } from './inventory.model'
import { CurrentWorkflowStep } from './workflow.model'

export interface ProcurementPurchaseRequestItemResponse {
  id: number
  type: PurchaseRequestItemType
  inventoryItem?: SimpleInventoryItemResponse
  name?: string
  description?: string
  quantity: number
  urgency?: number
  images: {
    id: number
    imageUrl: string
  }[]
  isResolved: boolean
  unit?: {
    id: number
    name: string
    coefficient: number
  }
}

export interface ProcurementPurchaseRequestQuoteItemResponse {
  id: number
  procurementPurchaseRequestItem: ProcurementPurchaseRequestItemResponse
  price: number
  createdAt: string
}

export interface SelectedQuote {
  id: number
  supplierName?: string
  quoteUrl: string
  type: QuoteType
  createdAt: string
  items: ProcurementPurchaseRequestQuoteItemResponse[]
  currency: string
  supplier?: Supplier
}

export interface ProcurementPurchaseRequestListResponse {
  id: number

  title: string

  clientStatus?: ProcurementRequestClientStatus

  clientCurrentStep?: string

  workflowSteps: CurrentWorkflowStep[]

  requesterUser?: UserSimpleResponse

  department: SimpleDepartmentResponse

  costCenter?: CostCenter

  creationStatus: ProcurementCreationStatus

  canResolveWorkflowStep: boolean

  status?: ProcurementStatus

  priority: ProcurementPriority

  selectedQuote?: SelectedQuote

  createdAt: string

  items: ProcurementPurchaseRequestItemResponse[]

  currentWorkflowStep?: CurrentWorkflowStep

  isPOCreated: boolean
}

export interface CreateProcurementPurchaseRequestItemDto {
  type: PurchaseRequestItemType

  // Required when type = ITEM
  inventoryItemId?: number

  // Required when type = TEXT
  name?: string
  description?: string

  quantity: number
  unitId: number

  urgency?: number
}

export interface CreateProcurementPurchaseRequestDto {
  title: string
  departmentId: number
  costCenterId?: number

  notes?: string
  preferredSupplierId?: number

  priority: ProcurementPriority

  // Required when priority = CRITICAL
  reason?: string

  items: CreateProcurementPurchaseRequestItemDto[]
}

export enum ProcurementQuoteType {
  Document = 1,
  Manual = 2,
}

export interface ProcurementPurchaseRequestQuoteResponse {
  id: number
  quoteUrl: string
  type: ProcurementQuoteType

  supplierName?: string
  supplier?: Supplier

  currency: string
  deliveryTimeInDays?: number
  totalPrice?: number

  createdAt: string

  items: ProcurementPurchaseRequestQuoteItemResponse[]
}

export enum SupplierStatus {
  Active = 1,
  Inactive = 2,
}

export interface Supplier {
  id: number
  name: string
  phoneNumber?: string
  address?: string
  vatId?: string
  email?: string
  status: SupplierStatus
}

export type ProcurementPurchaseRequestDetailsResponse = ProcurementPurchaseRequestListResponse & {
  notes?: string

  preferredSupplier?: Supplier

  reason?: string

  quotes: ProcurementPurchaseRequestQuoteResponse[]

  workflowSteps: CurrentWorkflowStep[]

  canResolveWorkflowStep?: boolean

  canQuoteOrChooseWinningQuote?: boolean
}

export interface AddProcurementPurchaseRequestOfferItemRequest {
  procurementPurchaseRequestItemId: number
  price: number
}

export interface AddProcurementPurchaseRequestOfferRequest {
  type: ProcurementQuoteType
  supplierName?: string
  supplierId?: number
  currency: string
  deliveryTimeInDays?: number
  items?: AddProcurementPurchaseRequestOfferItemRequest[]
}

export interface SelectWinningOfferRequest {
  shouldAddSupplier: boolean
  supplier?: Omit<Supplier, 'id'>
}
